import React from "react";
import "../css/PasswordReset.css";
import dogCatImage from "../assets/view-cats-dogs-showing-friendship 1.png";
import { Link } from "react-router-dom";
const PasswordReset = () => {
  return (
    <div className="pr-login-container">
      <div className="pr-login-left">
        <h2 className="pr-login-left-header">
          Reset Your Password – Reconnect With Your Pet’s World!
        </h2>
        <img className="pr-image" src={dogCatImage} alt="Dog and Cat" />
      </div>
      <div className="pr-login-right">
        <h2 className="pr-login-right-header">Password reset</h2>
        <p className="pr-instruction">
          Your password has been successfully reset. click confirm to set a new
          password
        </p>

        <Link to="/new-password" className="pr-confirm-button">
          Confirm
        </Link>
      </div>
    </div>
  );
};

export default PasswordReset;